export default __webpack_public_path__ + "components/weather-icon/static/nightheavyrain-6548410084935587fd1519bd8b27d2a4.webp";